import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/select/js/design-tokens-px.css.js';
import style from './mc-select.scss';
export const styles: CSSResultArray = [host, tokens, style];
